import { faCalendar, faClock } from "@fortawesome/free-regular-svg-icons";
import { faBarcode, faMoneyBillWave } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import Style from "./ReceivedOrders.module.css";
import { separate } from "../../Functions/NumberSeprator";
import Button from "../Button/Button";
import Factor from "../Factor/Factor";
import Modal from "../Modal/Modal";
import PreparationTime from "../PreparationTime/PreparationTime";
import {
  orderListDetailApi,
  ReceivedOrdersAPI,
} from "../../Api/SupplierServices";
import LoadingComponet from "../LoadingComponet/LoadingComponet";
import { getSupplierInfoAPi, logOutApi } from "../../Api/BarestSupplierServices";
import { useHistory } from "react-router-dom";
const ReceivedOrders = () => {
  const [prepareShow, setPrepareShow] = useState(false);
  const [factorShow, setFactorShow] = useState(false);
  const [orders, setOrders] = useState();
  const [orderID, setOrderID] = useState();
  const MINUTE_MS = 30000;
  let history= useHistory()
  useEffect(() => {
    getOrdersList();
    getSupplierInfo()
    const interval = setInterval(() => {
      getOrdersList();
    }, MINUTE_MS);
    return () => clearInterval(interval);
  }, []);

  const LogoutHandler = () => {
    let info = {
      logout: "",
    };
    logOutApi(info, (succ) => {
      console.log(succ);
    });
  };
  //////////// get supplier info /////////////
  const getSupplierInfo = async () => {
    const result = await getSupplierInfoAPi();
    if (localStorage.getItem("supplierToken")) {
      if (result.status === -2) {
        LogoutHandler();
        localStorage.clear();
        history.push("/login");
        setTimeout(() => {
          window.location.reload();
        }, 100);
      } else if (result.info.lat === "" && result.info.lon === "") {
        setTimeout(() => {
          history.push("/selectaddress");
        }, 0);
      }
    }
  };
  const [orderListDetails, setOrderListDetails] = useState();

  const getOrderListsDetail = async (id) => {
    const data = await orderListDetailApi(id);
    setOrderListDetails(data);
  };

  const FactorListHandler = (id) => {
    setFactorShow(true);
    getOrderListsDetail(id);
    setOrderID(id);
  };
  const setTimePreparation = (id) => {
    setPrepareShow(true);
    setOrderID(id);
  };

  const getOrdersList = async () => {
    const data = await ReceivedOrdersAPI();
    let sorted = [...data.orders].sort((a, b) => {
      return a.id > b.id ? -1 : 1;
    });
    setOrders(sorted);
  };
  let loadingHandler = null;
  if (orders === undefined) {
    loadingHandler = <LoadingComponet />;
  } else if (orders.length === 0) {
    loadingHandler = (
      <div className={Style.NotOrderFoundHolder}>
        <div className={Style.ImageBasket}>
          <img src="/Assets/Images/Order/emtyOreder.svg" alt="barest" />
        </div>
        <p className={Style.NoOrderText}>سفارشی یافت نشد</p>
      </div>
    );
  } else {
    loadingHandler = orders.map((item, index) => {
      return (
        <ul key={index} className={Style.EachPart__ul}>
          <li className={Style.EachPart__li__Date}>
            <div>
              <FontAwesomeIcon icon={faCalendar} />
              {item.date.split(" ")[0]}
            </div>
            <div>
              <FontAwesomeIcon icon={faClock} />
              {item.date.split(" ")[1]}
            </div>
          </li>
          <li className={Style.EachPart__li}>
            <FontAwesomeIcon icon={faBarcode} />
            کد پیگیری: <span>{item.id}</span>
          </li>
          <li className={Style.EachPart__li}>
            <FontAwesomeIcon icon={faMoneyBillWave} /> مبلغ کل:{" "}
            <p className={Style.price}>{separate(item.cart)} تومان</p>
          </li>
          <li className={Style.EachPart__li}>
            <FontAwesomeIcon icon={faMoneyBillWave} /> کمیسیون:{" "}
            <p className={Style.redPrice}>{separate(item.cart_fee)} تومان</p>
          </li>

          <li className={Style.BtnHolder}>
            <Button
              Value={"قبول سفارش"}
              ClassBtn={"confirmBtn"}
              ClickHandler={() => setTimePreparation(item.id)}
            />
            <Button
              Value={"لیست سفارش"}
              ClassBtn={"borderRed"}
              ClickHandler={() => FactorListHandler(item.id)}
            />
          </li>
        </ul>
      );
    });
  }
  return (
    <ul className={Style.ComponentHolder}>
      <Modal
        show={factorShow}
        modalClose={() => setFactorShow(false)}
        translate={40}
      >
        <Factor orderID={orderID} data={orderListDetails} />
      </Modal>
      
      <Modal
        show={prepareShow}
        modalClose={() => setPrepareShow(false)}
        translate={40}
      >
        <PreparationTime orderID={orderID} closemodal={() => setPrepareShow(false)}/>
      </Modal>
      <li className={Style.EachPart}>{loadingHandler}</li>
    </ul>
  );
};

export default ReceivedOrders;
